import React from "react";
import * as ReactHookForm from "react-hook-form";
import "../../styles/MainPage.scss";
import Drawer from "../drawer/Drawer";
import ContractForm from "../contract-form/ContractForm";
import StepIndicator from "../step-indicator/StepIndicator";
import GapButton from "../gap-button/GapButton";
import { getContractDetails, createClaim, getExistingClaimDetails, getInstructionalDoc } from "../../services/MainPage.Service";
import ContractNotFound from "../contract-not-found/ContractNotFound";
import ContractDetails from "../contract-details/ContractDetails";
import VerifyInformation from "../verify-information/VerifyInformation";
import ClaimDetails from "../claim-details/ClaimDetails";
import Loader from "../loader/Loader";
import ExistingClaimForm from "../existing-claim/ExistingClaimForm";
import ClaimNotFound from "../claim-not-found/ClaimNotFound";
import LenderIdentification from "../lender-identification/LenderIdentification";
import ExistingClaimStatus from "../existing-claim-status/ExistingClaimStatus";
import ContractList from "../contract-list/ContractList";
const steps = ["contractForm", "claimDetail", "verifyInfo", "tellUsWhatHappen"];

const stepperActionButton = ["Find your Contract", "Next, Start Claim", "Next, Claim Details", "Next, View Claim"];
const MainPage = (props) => {
    const { mainPageData, lenderActionsDetails, currentUser } = props;
    const [isShownAccessClaim, setIsShownAccessClaim] = React.useState(false);
    const [activeStep, setActiveStep] = React.useState(0);
    const firstForm = ReactHookForm.useForm({ mode: 'all' });
    const { handleSubmit, formState: { isValid }, reset } = firstForm;
    const isLastStep = activeStep === steps.length - 1;
    const [isShowContractNotFoundError, setIsShowContractNotFoundError] = React.useState(false);
    const [contractDetailsData, setContractDetailsData] = React.useState("");
    const [isPolicyExpired, setIsPolicyExpired] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
    const [isShowExistingClaim, setIsShowExistingClaim] = React.useState(false);
    const claimForm = ReactHookForm.useForm({ mode: 'all' });
    const { handleSubmit: claimHandleSubmit, formState: { isValid: isValidClaim }, reset: claimReset } = claimForm;
    const [isShowClaimNotFoundError, setIsShowClaimNotFoundError] = React.useState(false);
    const [isShowLenderIdentification, setIsShowLenderIdentification] = React.useState(false);
    const lenderForm = ReactHookForm.useForm({ mode: 'all' });
    const { handleSubmit: lenderHandleSubmit, formState: { isValid: isValidLender }, reset: lenderReset } = lenderForm;
    const [lenderDetails, setLenderDetails] = React.useState('');
    const [isShowExistingClaimStatus, setIsShowExistingClaimStatus] = React.useState(false);
    const [existingClaimDetails, setExistingClaimDetails] = React.useState(null);
    const [isClickedOnLenderAccessMenu, setIsClickedOnLenderAccessMenu] = React.useState(true);
    const [contractList, setContractList] = React.useState(null);
    const [isShowContractListDrawer, setIsShowContractListDrawer] = React.useState(false);
    const [displayContractList, setDisplayContractList] = React.useState(false);
    const [contractsLength, setContractsLength] = React.useState(null);
    const [isLenderAccessRequired, setIsShowLenderAccessRequired] = React.useState(false);
    const [lenderAction, setLenderAction] = React.useState("newClaim");

    const selectedContractDisplay = async (item) => {
        setIsLoading(true);
        const contractObj = {
            "contract_number": item?.number,
            "vin_number": item?.vehicle?.vin,
            "last_name": item?.customer?.lastName ?? item?.customer?.name,
            "contractId": item?.contractId
        };
        const data = await getContractDetails(contractObj).then((res) => { return res });
        localStorage.setItem('gcp-token', data?.headers?.authtoken);
        if(data?.data!=null){
            localStorage.setItem('sale-date', new Date(data?.data[0].saleDate));
        }
        if (!data?.data) {
            setIsLoading(false);
            setIsShowContractNotFoundError(true);
            return;
        }
        const contractDetailsResponse = data?.data[0];
        if (contractDetailsResponse?.status.toLowerCase() !== 'active' && contractDetailsResponse?.status.toLowerCase() !== 'inforce') {
            setIsPolicyExpired(true);
            setIsButtonDisabled(true);
        }
        const storageData = JSON.parse(localStorage.getItem('tpa_data'));
        if (!storageData?.policy_Types?.includes(contractDetailsResponse?.type)) {
            setIsButtonDisabled(true);
        }
        setIsShowContractListDrawer(false);
        setDisplayContractList(true);
        setContractDetailsData(contractDetailsResponse);
        setActiveStep(activeStep + 1);
        setIsLoading(false);
        return;
    }
    const callContractAPI = async (contractData) => {
        const contractObj = {
            "contract_number": contractData.gapContractNumber,
            "vin_number": contractData.vin,
            "last_name": contractData.contractLastName
        };
        const data = await getContractDetails(contractObj).then((res) => { return res });
        localStorage.setItem('gcp-token', data?.headers?.authtoken);
        // A missing contract arrives in several non-array shapes: the Api/BFF pass a
        // downstream 404/500 body (e.g. PureFi's text/plain "Could not find contract
        // ...") through as a string, and an empty result arrives as []. Only a
        // populated array is a real hit; anything else must route to the not-found
        // drawer rather than reaching .sort()/[0].saleDate/.status below, which throw
        // on a string/empty (mirrors the PATU-82 guard on the claim path).
        if (!Array.isArray(data?.data) || data.data.length === 0) {
            setIsShowContractNotFoundError(true);
            setIsLoading(false);
            return;
        }
        if(data?.data!=null){
            localStorage.setItem('sale-date', new Date(data?.data[0].saleDate));
        }
        if (data?.data?.length > 1) {
            const contractsReponse = data?.data;
            contractsReponse.sort((a, b) => b.saleDate.localeCompare(a.saleDate));
            setContractsLength(data?.data?.length);
            setContractList(contractsReponse);
            setIsShowContractListDrawer(true);
            setIsLoading(false);
            return;
        }
        if (!data?.data) {
            setIsShowContractNotFoundError(true);
            return;
        }
        const contractDetailsResponse = data?.data[0];
        if (contractDetailsResponse?.status.toLowerCase() !== 'active' && contractDetailsResponse?.status.toLowerCase() !== 'inforce') {
            setIsPolicyExpired(true);
            setIsButtonDisabled(true);
        }
        const storageData = JSON.parse(localStorage.getItem('tpa_data'));
        if (!storageData?.policy_Types?.includes(contractDetailsResponse?.type)) {
            setIsButtonDisabled(true);
        }

        setContractDetailsData(contractDetailsResponse);
        setActiveStep(activeStep + 1);
        setIsLoading(false);
        return;
    }

    const handleClaimDetails = async claimData => {
        setIsLoading(true);
        var claimObj = claimData;
        if (lenderDetails) {
            claimObj.lenderData = lenderDetails;
            setIsShowLenderIdentification(false);
        }
        var today = new Date();
        const reportedDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
        const reqObj = {
            "contract": { "number": contractDetailsData?.number },
            "gap": { "cause": claimData?.typeOfLoss },
            "lenderReg": lenderDetails ? {
                "name": lenderDetails?.lenderName,
                "phone": lenderDetails?.phoneNumber,
                "email": lenderDetails?.email
            } : null,
            "lossDate": claimData?.dateOfVehicleLoss,
            "lossOdometer": claimData?.odoMeter,
            "contactName": claimData?.contractHolderName,
            "contactEmail": claimData?.emailAddress,
            "complaint": claimData?.claimDescription,
            "customerPhone": claimData?.phoneNumber,
            "reportedDate": reportedDate,
            "question1": claimData?.question1,
            "question2": claimData?.question2,
            "question3": claimData?.question3
        };
        const data = await createClaim(reqObj).then((res) => { return res });
        if (data?.data) {
            localStorage.setItem('claim_number', JSON.stringify(data?.data));
            window.location = window.location.href + "/Claim";
            setActiveStep(0);
            setIsShownAccessClaim(false);
            document.body.style.overflow = "auto";
            setIsLoading(false);
            reset();
            return;
        }
    }

    const findExistingClaim = async () => {
        setIsLoading(true);
        const tpaData = JSON.parse(localStorage.getItem('tpa_data'));
        const queryParams = {
            "contract_number": contractDetailsData?.number,
            "last_name": tpaData.admin_Type === 'SEA' ? contractDetailsData?.customer?.name : contractDetailsData?.customer?.lastName,
            "claim_number": contractDetailsData?.claim_number,
            "vin": contractDetailsData?.vehicle?.vin
        }
        const data = await getExistingClaimDetails(queryParams).then((res) => { return res });

        // PATU-82: same empty-array guard as handleClaimSubmit. On the federated
        // path a holder with no existing claim gets a 200 with [], which is truthy
        // — without the length check the create wizard would treat the empty list
        // as an existing claim and divert to an empty status view instead of
        // letting the holder proceed to create. Only an EMPTY array is treated as
        // not-found; a populated array (or non-array payload) is still a hit.
        if (data?.data && (!Array.isArray(data.data) || data.data.length)) {
            setExistingClaimDetails(data?.data);
            // localStorage.setItem('claim_number', JSON.stringify(data?.data));
            setIsShowExistingClaimStatus(true);
            setIsLoading(false);
            return;
        }
        setIsLoading(false);
        setActiveStep(activeStep + 1);
        return;
    }

    const handleNext = async values => {
        if (!isButtonDisabled) {
            if (isValid || activeStep === 1) {
                if (!isLastStep) {
                    if (activeStep === 0) {
                        setIsLoading(true);
                        await callContractAPI(values);
                        setIsLoading(false);
                        return;
                    } else if (activeStep === 1) {
                        await findExistingClaim();
                        return;
                    }
                    else {
                        setActiveStep(activeStep + 1);
                        return;
                    }
                }
                await handleClaimDetails(values);
            }
        }
    }

    const handleBack = () => {
        if (activeStep > 0) {
            if (displayContractList && activeStep === 1) {
                setIsShowContractListDrawer(true);
            }
            setActiveStep(activeStep - 1);
            setIsButtonDisabled(false);
            setIsPolicyExpired(false);
            return;
        }

        if (isShowContractListDrawer) {
            setIsShowContractListDrawer(false);
            return;
        }

        if (isClickedOnLenderAccessMenu) {
            setIsShownAccessClaim(false);
            setIsShowLenderIdentification(true);
            setIsClickedOnLenderAccessMenu(true);
            return;
        }
        setIsShownAccessClaim(false);
        reset();
        showToggleHamburgerIcon();
        document.body.style.overflow = 'auto';
        return;
    }

    const handleClosedDrawer = () => {
        reset();
        claimReset();
        lenderReset();
        setActiveStep(0);
        setIsPolicyExpired(false);
        setIsButtonDisabled(false);
        setIsShownAccessClaim(false);
        setIsShowContractNotFoundError(false);
        setIsShowExistingClaim(false);
        setIsShowClaimNotFoundError(false);
        setIsShowExistingClaimStatus(false);
        setIsShowLenderIdentification(false);
        showToggleHamburgerIcon();
        setIsShowContractListDrawer(false);
        setContractList(null);
        setDisplayContractList(false);
        setContractsLength(null);
        document.body.style.overflow = "auto";
        return;
    }

    const closedErrorDrawer = () => {
        setIsShowContractNotFoundError(false);
    }

    const renderStepContent = (step) => {
        switch (step) {
            case 0:
                return <ContractForm formHeading="Locate your Contract" contractForm={firstForm} serviceNumber={mainPageData.tel} currentUser={currentUser} />;
            case 1:
                return <ContractDetails contractDetailsData={contractDetailsData} policyExpired={isPolicyExpired} />;
            case 2:
                return <VerifyInformation contractForm={firstForm} contractDetailsData={contractDetailsData} />;
            case 3:
                return <ClaimDetails contractForm={firstForm} />;
            default:
                return <div>Not Found</div>;
        }
    }

    const showToggleHamburgerIcon = () => {
        var toggleElement = document.getElementsByClassName("nav-bar")[0];
        if (toggleElement) {
            toggleElement.style.display = "";
            return;
        }
        return;
    }

    const hideToggleHamburgerIcon = () => {
        var toggleElement = document.getElementsByClassName("nav-bar")[0];
        if (toggleElement) {
            toggleElement.style.display = "none";
            return;
        }
        return;
    }

    const handleTheme = () => {
        document.documentElement.style.setProperty('--button-primary-color',mainPageData?.custom_theme?.primary_button_color && mainPageData?.custom_theme?.primary_button_color);
        document.documentElement.style.setProperty('--already-claim-link',mainPageData?.custom_theme?.existing_claim_link_color && mainPageData?.custom_theme?.existing_claim_link_color);
        document.documentElement.style.setProperty('--header-background-color',mainPageData?.custom_theme?.header_background_color && mainPageData?.custom_theme?.header_background_color);
        document.documentElement.style.setProperty('--footer-background-color',mainPageData?.custom_theme?.footer_background_color && mainPageData?.custom_theme?.footer_background_color);
        document.documentElement.style.setProperty('--leinholder-menu-color',mainPageData?.custom_theme?.lienholder_menu_color && mainPageData?.custom_theme?.lienholder_menu_color);
        document.documentElement.style.setProperty('--button-disable-color',mainPageData?.custom_theme?.disabled_button_color && mainPageData?.custom_theme?.disabled_button_color);
        document.documentElement.style.setProperty('--warning-color',mainPageData?.custom_theme?.warning_color && mainPageData?.custom_theme?.warning_color);
        document.documentElement.style.setProperty('--footer-color',mainPageData?.custom_theme?.footer_color && mainPageData?.custom_theme?.footer_color);
        // document.body.className = mainPageData.theme_Name ? mainPageData.theme_Name : 'Theme-Sefi';
    }

    React.useEffect(() => {
        const localStorageData = JSON.parse(localStorage.getItem("tpa_data"));
        if (localStorageData?.is_lender_access_required) {
            setIsShowLenderAccessRequired(true);
        }
    }, [])

    React.useEffect(() => {
        handleTheme();
        // handleTheme reads mainPageData props once on mount; re-running on every render would re-set theme vars unnecessarily.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        if (lenderActionsDetails?.isShowLenderIdentification) {
            hideToggleHamburgerIcon();
        } else {
            showToggleHamburgerIcon();
        }
        setIsShowLenderIdentification(lenderActionsDetails?.isShowLenderIdentification);
        setIsClickedOnLenderAccessMenu(lenderActionsDetails?.isShowLenderIdentification);
    }, [lenderActionsDetails])

    const setButtonDisabled = () => {
        if (isButtonDisabled && activeStep === 1) {
            return true;
        } else {
            if (!isValid && activeStep !== 1) {
                return true;
            }
            return false;
        }
    }

    ////Existing Claim Methods

    const handleClaimSubmit = async values => {
        if (isValidClaim) {
            setIsLoading(true);
            setIsShowLenderIdentification(false);
            const queryParams = {
                "claim_number": values?.claimNumber,
                "contract_number": values?.contractNumber,
                "last_name": values?.lastName
            }
            const data = await getExistingClaimDetails(queryParams).then((res) => { return res });
            // PATU-82: the federated subject filter returns 200 with an empty array
            // for a withheld/denied claim. An empty array is truthy, so guarding on
            // data?.data alone entered the success branch and then threw on
            // data.data[0].saleDate. Require a non-empty result so an empty array
            // falls through to the not-found drawer (same surface a 404 shows).
            if (data?.data && data.data.length) {
                setExistingClaimDetails(data?.data);
                // localStorage.setItem('claim_number', JSON.stringify(data?.data));
                localStorage.setItem('gcp-token', data.headers.authtoken);
                if(data?.data!=null){
                    localStorage.setItem('sale-date', new Date(data?.data[0].saleDate));
                }
                setIsShowExistingClaimStatus(true);
                setIsLoading(false);
                return;
            }
            setIsShowClaimNotFoundError(true);
            setIsLoading(false);
            return;
        }
    }

    const closedClaimErrorDrawer = () => {
        setIsShowClaimNotFoundError(false);
    }

    ////Lender Access methods

    const handleLenderSubmit = values => {
        if (isValidLender) {
            setLenderDetails(values);
            setIsShowLenderIdentification(false);

            if (isLenderAccessRequired) {
                if (lenderAction === 'newClaim') {
                    setIsShownAccessClaim(true);
                    return;
                }
                if (lenderAction === 'existingClaim') {
                    setIsShowExistingClaim(true);
                    return;
                }
            } else {
                if (lenderActionsDetails?.lenderAction === 'newClaim') {
                    setIsShownAccessClaim(true);
                    return;
                }
                if (lenderActionsDetails?.lenderAction === 'existingClaim') {
                    setIsShowExistingClaim(true);
                    return;
                }
            }
        }
    }

    const closedLenderDrawer = () => {
        setIsShowLenderIdentification(false);
        lenderReset();
        showToggleHamburgerIcon();
        document.body.style.overflow = "auto";
        return;
    }

    const handleClaimLookUpBack = () => {
        setIsShowExistingClaim(false); //claimReset();
        if (isClickedOnLenderAccessMenu) {
            setIsShowLenderIdentification(true);
            setIsClickedOnLenderAccessMenu(true);
        }
        document.body.style.overflow = "auto";
        showToggleHamburgerIcon();
        return;
    }

    ////Existing Claim Status Methods

    const handleValidExistingClaimStatus = (data) => {
        localStorage.setItem('claim_number', JSON.stringify(data));
        window.location = window.location.href + "/Claim";
        setIsShowExistingClaimStatus(false);
        handleClosedDrawer();
        return;
    }


    //// Get and download instructional document data if it's enabled by admin portal
    const getInstructionalDocData = async () => {
        setIsLoading(true);
        var url = location.pathname.split('/');
        document.body.style.overflow = 'hidden';
        const res = await getInstructionalDoc(url[1]).then((data) => { return data; });
        if (res.data) {
            // var reader = new FileReader();
            // var content = reader.readAsDataURL(res.data);
            // reader.onload = () => {
            //     const downloadLink = document.createElement("a");
            //     downloadLink.href = reader.result;
            //     downloadLink.download = "Doc.pdf";
            //     window.open(downloadLink,'_blank');
            //     // downloadLink.click();
            //     setIsLoading(false);
            // }
            const file = new Blob([res.data], {type : 'application/pdf'});
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL,'_blank');
            document.body.style.overflow = 'auto';
            setIsLoading(false);
            return;
        }
        setIsLoading(false);
        document.body.style.overflow = 'auto';
        return;
    }

    return (
        <React.Fragment>
            {isLoading ? <Loader /> : ""}
            <section className="banner-section">
                <div className="container">
                    <h4 className="banner-heading">Claims Center</h4>
                    <h2 className="banner-subheading">We&apos;re here for you</h2>
                    <p className="banner-description">
                        {mainPageData.body_Text}
                    </p>
                    <div className="col-heading">
                        <h4>We’ll guide you through each step in the Claim process. </h4>
                    </div>
                    <div className="row">
                        <div className="col-test">
                            <div className="banner-col-block">
                                <div className="number-block">
                                    <span className="banner-col-block col-block__number">1</span>
                                </div>
                                <div className="col-block__text">
                                    <h4 className="col-block__heading">Get Ready...</h4>
                                    <p className="col-block__description">{mainPageData.locate_Gap_Text}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-test">
                            <div className="banner-col-block mt-md-30 mt-sm-14">
                                <div className="number-block">
                                    <span className="banner-col-block col-block__number">2</span>
                                </div>
                                <div className="col-block__text">
                                    <h4 className="col-block__heading">Start your claim</h4>
                                    <p className="col-block__description">{mainPageData.your_Infor_Text}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-test">
                            <div className="banner-col-block mt-md-30 mt-sm-14">
                                <div className="number-block">
                                    <span className="banner-col-block col-block__number">3</span>
                                </div>
                                <div className="col-block__text">
                                    <h4 className="col-block__heading">Check your claim status</h4>
                                    <p className="col-block__description">{mainPageData.gather_Doc_Text}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="banner-btn">
                        <div className="w-33">
                            {mainPageData.show_instructionDoc_on_welcome_screen &&
                                <GapButton
                                    buttonType="button"
                                    id="instruction-doc-button"
                                    buttonClass="instruction-doc-button"
                                    buttonLabel="Download Instructions"
                                    onClick={() => { getInstructionalDocData(); }}
                                />
                            }
                        </div>
                        {isShownAccessClaim &&
                            <Drawer closeDrawer={handleClosedDrawer} isOpenedDrawer={isShownAccessClaim}>
                                <div className="mt-20">
                                    {
                                        isShowContractNotFoundError ? <ContractNotFound closedErrorDrawer={closedErrorDrawer} serviceNumber={mainPageData.tel} /> :
                                            isShowExistingClaimStatus ? <ExistingClaimStatus handleBack={() => { setIsShowExistingClaimStatus(false) }} handleNext={(data) => { handleValidExistingClaimStatus(data) }} claimDetails={existingClaimDetails} /> :
                                                isShowContractListDrawer ? <ContractList contractListData={contractList} selectedContractDisplay={(item) => { selectedContractDisplay(item) }} handleBack={handleBack} contractsLength={contractsLength} /> :
                                                    <StepIndicator
                                                        totalStepper={4}
                                                        activeStepper={activeStep}
                                                    >

                                                        <div className="mt-36">
                                                            <form onSubmit={handleSubmit(handleNext)} className="claim-form">
                                                                {renderStepContent(activeStep, props)}
                                                                <div className="mt-20 stepper-btn" id="stepperBtn">
                                                                    <GapButton onClick={handleBack} id="drawer-back-button" buttonType="button" buttonClass="back-btn cursor-pointer" buttonLabel="Back" />
                                                                    <GapButton
                                                                        buttonType="submit"
                                                                        id="drawer-submit-button"
                                                                        buttonClass={setButtonDisabled() ? "next-btn next-btn--disabled cursor-pointer" : "next-btn cursor-pointer"}
                                                                        buttonLabel={stepperActionButton[activeStep]}
                                                                        disabled={setButtonDisabled()}
                                                                    />
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </StepIndicator>
                                    }
                                </div>
                            </Drawer>
                        }
                        <div className="w-33">
                            <GapButton buttonType="button" id="claim-button" buttonClass="claim-btn cursor-pointer" buttonLabel="Start Your Claim" onClick={() => {
                                if (isLenderAccessRequired) {
                                    setIsShowLenderIdentification(true);
                                    setLenderAction("newClaim");
                                } else {
                                    setIsShownAccessClaim(true);
                                }
                                hideToggleHamburgerIcon();
                            }} />
                        </div>
                        {isShowExistingClaim &&
                            <Drawer closeDrawer={handleClosedDrawer} isOpenedDrawer={isShowExistingClaim}>
                                <div className="mt-20">
                                    {
                                        isShowClaimNotFoundError ? <ClaimNotFound closedErrorDrawer={closedClaimErrorDrawer} serviceNumber={mainPageData.tel} /> :
                                            isShowExistingClaimStatus ? <ExistingClaimStatus handleBack={() => { setIsShowExistingClaimStatus(false) }} handleNext={(data) => { handleValidExistingClaimStatus(data) }} claimDetails={existingClaimDetails} /> :
                                                <form onSubmit={claimHandleSubmit(handleClaimSubmit)} className="claim-form">
                                                    <ExistingClaimForm claimFormRef={claimForm} serviceNumber={mainPageData.tel} currentUser={currentUser} />
                                                    <div className="mt-20 stepper-btn" id="stepperBtn">
                                                        <GapButton onClick={handleClaimLookUpBack} id="drawer-back-button" buttonType="button" buttonClass="back-btn cursor-pointer" buttonLabel="Back" />
                                                        <GapButton
                                                            buttonType="submit"
                                                            id="drawer-submit-button"
                                                            buttonLabel="Find Your Claim"
                                                            buttonClass={isValidClaim ? "next-btn cursor-pointer" : "next-btn next-btn--disabled cursor-pointer"}
                                                            disabled={!isValidClaim}
                                                        />
                                                    </div>
                                                </form>
                                    }
                                </div>
                            </Drawer>
                        }
                        <div className="w-33">
                            <GapButton buttonType="button" id="existing-claim-button" buttonClass="btn-already__claim cursor-pointer" buttonLabel="I Already Have a Claim" onClick={() => {
                                if (isLenderAccessRequired) {
                                    setIsShowLenderIdentification(true);
                                    setLenderAction("existingClaim");
                                } else {
                                    setIsShowExistingClaim(true);
                                    setIsClickedOnLenderAccessMenu(false);
                                }
                                hideToggleHamburgerIcon();
                            }} />
                        </div>
                    </div>
                    {isShowLenderIdentification &&
                        <div className="lender-drawer-container">
                            <Drawer closeDrawer={closedLenderDrawer} isOpenedDrawer={isShowLenderIdentification}>
                                <div className="mt-20">
                                    <form onSubmit={lenderHandleSubmit(handleLenderSubmit)} className="claim-form">
                                        <LenderIdentification lenderForm={lenderForm} />
                                        <div className="mt-20 stepper-btn" id="stepperBtn">
                                            <GapButton onClick={closedLenderDrawer} id="drawer-back-button" buttonType="button" buttonClass="back-btn cursor-pointer" buttonLabel="Back" />
                                            <GapButton
                                                buttonType="submit"
                                                id="drawer-submit-button"
                                                buttonLabel="Next"
                                                buttonClass={isValidLender ? "next-btn cursor-pointer" : "next-btn next-btn--disabled cursor-pointer"}
                                                disabled={!isValidLender}
                                            />
                                        </div>
                                    </form>
                                </div>
                            </Drawer>
                        </div>
                    }
                </div>
            </section>
        </React.Fragment>
    );
};

export default MainPage;